import {ArrowUpRightIcon} from '@primer/octicons-react'
import styles from './PlaygroundCard.module.css'
import type React from 'react'
import {clsx} from 'clsx'
import {testIdProps} from '@github-ui/test-id-props'

type PlaygroundCardSize = 'small' | 'large'

export function PlaygroundCard({
  sample,
  onAction,
  size = 'small',
}: {
  sample: string
  onAction: (e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>) => void
  size?: PlaygroundCardSize | {narrow: PlaygroundCardSize; regular: PlaygroundCardSize}
}) {
  function handleOnKeyPress(event: React.KeyboardEvent<HTMLDivElement>) {
    // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
    if (event.key === 'Enter') {
      onAction(event)
    }
  }

  // A responsive size renders both breakpoint-scoped classes at once; only the one whose media
  // query currently matches takes effect, so no JS hook is needed to pick between them.
  const sizeClassNames =
    typeof size === 'string' ? styles[size] : clsx(styles[`${size.narrow}Narrow`], styles[`${size.regular}Regular`])

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={handleOnKeyPress}
      onClick={onAction}
      className={clsx(styles.playgroundCard, sizeClassNames)}
      {...testIdProps('playground-card')}
    >
      <div className={styles.sampleContainer}>{sample}</div>
      <div className={styles.chevronContainer}>
        <ArrowUpRightIcon />
      </div>
    </div>
  )
}
